import React, { useState } from 'react';

import clsx from 'clsx';

import { CheckedImage, HourglassImage, VerifyImage } from 'assets/icons';
import Loader from 'components/Loader';

import styles from './InteractiveBox.module.scss';

export enum InteractiveBoxStatus {
  Initial = 'Initial',
  Pending = 'Pending',
  Completed = 'Completed',
  InitialConnect = 'InitialConnect',
}

const VerifyNowText = ({ text }: { text: string }) => <p className={styles.textOrange}> {text}</p>;
const Text = ({ text }: { text: string }) => <p className={styles.text}>{text}</p>;

const statusesComponentsMap = {
  [InteractiveBoxStatus.Initial]: {
    icon: <VerifyImage />,
    text: <VerifyNowText text={'Verify Now!'} />,
    boxStyle: styles.box_initial,
  },
  [InteractiveBoxStatus.InitialConnect]: {
    icon: <VerifyImage />,
    text: <VerifyNowText text={'Connect!'} />,
    boxStyle: styles.box_initial,
  },
  [InteractiveBoxStatus.Pending]: {
    icon: <HourglassImage />,
    text: <Text text="Pending" />,
    boxStyle: styles.box_pending,
  },
  [InteractiveBoxStatus.Completed]: {
    icon: <CheckedImage />,
    text: <Text text="Completed" />,
    boxStyle: styles.box_success,
  },
};

interface InteractiveBoxProps {
  title: JSX.Element | string;
  onClick: () => Promise<void> | void;
  status?: InteractiveBoxStatus;
  asyncLoading?: boolean;
  boxClassName?: string;
}

const InteractiveBox = ({
  status = InteractiveBoxStatus.Initial,
  title,
  onClick,
  asyncLoading = false,
  boxClassName,
}: InteractiveBoxProps) => {
  const { icon, text, boxStyle } = statusesComponentsMap[status];

  const [loading, setLoading] = useState<boolean>(false);

  const getOnClickEvent = () => {
    if (loading) {
      return () => {};
    }

    if (!asyncLoading) {
      return onClick;
    } else {
      return async () => {
        setLoading(true);
        await onClick();
        setLoading(false);
      };
    }
  };

  return (
    <div className={clsx(styles.box, boxStyle, boxClassName)} onClick={getOnClickEvent()}>
      {loading && asyncLoading ? (
        <Loader containerWithoutMargin size={50} />
      ) : (
        <>
          <div className={styles.title}>{title}</div>
          {icon}
          {text}
        </>
      )}
    </div>
  );
};

export default InteractiveBox;
